import api from './api';

// Account Statement — point_ledger based V2 report.
// Body: { reportType: 'TRANSACTION'|'SPORTS', clientName, fromDate, toDate,
//         page, limit, statement, sportId, gameType, casinoType }
// Server pe maxDateRange(7) lagi hai, isliye range 7 din se zyada nahi.
export const getStatementV2 = async (params) => {
  const response = await api.post('/admin/reports/statementv2', params);
  return response.data;
};

// User Win Loss — point_ledger based category-wise report
// (CASINO / SPORTS / SPORTSBOOK / THIRD_PARTY).
// Body: { clientName, fromDate, toDate } — dateRangeMiddleware dono dates
// maangta hai, max 10 din ki window aur pichhle 3 mahine ke andar.
export const getPointCategoryReport = async (params) => {
  const response = await api.post('/admin/reports/point-category-report', params);
  return response.data;
};

// Account Statement row ka Result modal — bet ke round (CASINO) / market (SPORTS)
// ke bets + winner. Body: { betId, category: 'CASINO'|'SPORTS' }.
// Response shape user statement wali service jaisi: { header, winner, bets, ... }.
export const getStatementBetResult = async (params) => {
  const response = await api.post('/admin/reports/statementv2/bet-result', params);
  return response.data;
};

// Statement ki "Live Casino" row — provider list, ya ek provider ke third-party bets.
// params: { clientName, fromDate, toDate, provider? } — statement wale hi
export const getStatementLiveCasino = async (params) => {
  const response = await api.post('/admin/reports/statementv2/live-casino', params);
  return response.data;
};
